import { Typography, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import '../../styles/Globales.scss';
import '../../styles/SolicitarPortabilidad.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

const SI = 'SI';
const NO = 'NO';

export default class RetractoComponent extends Component {
  constructor(props) { // eslint-disable-line
    super(props);
  }

  onSeleccionChange = (evt) => {
    const value = evt.target.value;
    if (this.props.onSeleccionChange) {
      this.props.onSeleccionChange(value);
    }
  };

  render() {
    let classSi = 'none';
    let classNo = 'none';
    if (this.props.portarTodos === SI) {
      classSi = 'bordeDestacado';
    } else if (this.props.portarTodos === NO) {
      classNo = 'bordeDestacado';
    }
    return (
      <div className="retractoContenedor">
        <Typography className="preguntaPortar">¿Deseas finalizar el proceso?</Typography>
        <RadioGroup aria-label="gender" name="gender1" className="opcionesCompromiso Grande" value={this.props.portarTodos} onChange={this.onSeleccionChange}>
          <FormControlLabel control={<Radio color="primary" />} label="Si" className={classNo} value={NO} />
          <FormControlLabel control={<Radio color="primary" />} label="No, quiero arrepentirme" className={classSi} value={SI} />
        </RadioGroup>
      </div>
    );
  }
}

RetractoComponent.propTypes = {
  onSeleccionChange: PropTypes.func.isRequired,
  portarTodos: PropTypes.string,
}
